/* src/app/feature-modules/tutor-list/create-edit-tutor/create-edit-tutor.component.css */
.fileUpload {
  position: relative;
  display: inline-flex;
}
.fileUpload__image {
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
  border-radius: 100%;
  background-color: #F4F8F9;
  border: 4px solid #F8F8F8;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
}
.fileUpload__image img {
  display: block;
  width: 100%;
  height: 100%;
}
.fileUpload__file,
.fileUpload__file input {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
.fileUpload__file input {
  height: 100%;
  opacity: 0;
  width: 100%;
}
.custom-select-position {
  margin-top: 25px !important;
}
ngx-mat-select-search {
  position: relative;
  display: block;
}
.mat-select-search-inner {
  width: 100% !important;
}
/*# sourceMappingURL=create-edit-tutor.component.css.map */
